<template>
  <el-row class="main-sidebar-nav">
    <el-col class="logo-box" :xs={span:0} :sm={span:6} :md={span:5,offset:2} :lg={span:5,offset:4}>
      <img src="@/assets/images/logo.png">
    </el-col>
    <el-col class="hidden-sm-and-up" :xs={span:3}>
      <el-button icon="el-icon-menu" circle @click="navflag = !navflag"></el-button>
    </el-col>
    <el-col :class="[this.navflag?'nav-hide':'']" :xs={span:21} :sm={span:18} :md={span:15} :lg={span:11}>
      <el-menu :default-active="$route.path" router class="el-menu-demo" mode="horizontal">
        <el-menu-item index="/main">首页</el-menu-item>
        <el-submenu index="2">
          <template slot="title">产品中心</template>
          <el-menu-item index="/main/fusionGateway2">融合网关2.0</el-menu-item>
          <el-menu-item index="/main/smartScreen">私密投屏</el-menu-item>
          <el-menu-item index="/main/SDWAN">SD-WAN</el-menu-item>
          <el-menu-item index="/main/routeDev">路由流控</el-menu-item>
          <!-- <el-menu-item index="/main/fusionGateway">融合网关</el-menu-item> -->
          <el-menu-item index="/main/smartTV">智慧桌面</el-menu-item>
          <el-menu-item index="/main/logAudit">日志审计</el-menu-item>
          <el-menu-item index="/main/SDWAN-Client">SD-WAN软终端</el-menu-item>
        </el-submenu>
        <el-menu-item index="/main/cooperative">合作加盟</el-menu-item>
        <el-menu-item index="/main/service">技术售后</el-menu-item>
        <el-menu-item index="/main/download">下载中心</el-menu-item>
        <!-- <el-submenu index="3">
          <template slot="title">关于我们</template>
        </el-submenu> -->
        <el-menu-item index="/main/aboutUS">关于我们</el-menu-item>
        <el-menu-item index="/main/JoinUs">加入我们</el-menu-item>
        <el-menu-item><a class="nav-bbs" href="http://bbs.xspeeder.com/" target="_blank">进入论坛</a></el-menu-item>
      </el-menu>
    </el-col>
  </el-row>
</template>
<script>
  export default {
    data(){
      return{
        navflag:true
      }
    }
  }
</script>
<style lang="scss" scoped>
  .main-sidebar-nav{
    height: 100%;
    overflow: hidden;
  }
  .main-sidebar-nav .el-menu--horizontal>.el-menu-item.is-active,.main-sidebar-nav .el-menu--horizontal .el-menu .el-menu-item.is-active{
    color: #409eff !important;
  }
  .main-sidebar-nav .el-menu.el-menu--horizontal {
    border-bottom: 0;
  }
  .nav-bbs{
    border: 1px solid #909399;
    padding: 3px 3px 3px 20px;
    background: url("../../assets/images/icon-forum.png") no-repeat;
    background-position-y: center;
    background-position-x: 3px;
    font-size: 12px;
  }
  @media screen and (max-width: 767px){
    .main-sidebar-nav{
      padding: 5px 0;
      background: url("../../assets/images/logo.png") #fff no-repeat center center;
    }
  }
  
  @media screen and (min-width: 768px){
    .main-sidebar-nav .logo-box{
      height: 100%;
      position: relative;
    }
    .main-sidebar-nav .logo-box img{
      position: absolute;
      top: 50%;
      transform: translate(10px , -50%);
    }
    
    .main-sidebar-nav .el-menu-demo li{
      width: 12%;
      text-align: center;
    }
    .main-sidebar-nav .el-menu--horizontal>.el-submenu .el-submenu__icon-arrow{
      margin-left: 4px !important;
    }
  }
</style>
<style lang="scss">
  .main-sidebar-nav .nav-hide{
    display: none;
  }
  .el-menu--popup{
    min-width: 120px !important;
  }
  @media screen and (max-width: 767px){
    .main-sidebar-nav .el-menu-item,.main-sidebar-nav .el-menu--horizontal>.el-submenu .el-submenu__title{
      height: 40px !important;
      line-height: 40px !important;
    }
    .main-sidebar-nav .el-menu-item, .main-sidebar-nav .el-submenu__title{
      padding: 0 10px !important;
    }
    .main-sidebar-nav .el-menu--horizontal>.el-submenu .el-submenu__icon-arrow{
      margin-left: 4px!important;
    }
  }
  @media screen and (min-width: 768px){
    .main-sidebar-nav .nav-hide{
      display: block;
    }
    .main-sidebar-nav .el-menu-item, .main-sidebar-nav .el-submenu__title{
      padding: 0 !important;
    }
    .main-sidebar-nav .el-menu--horizontal>.el-submenu .el-submenu__icon-arrow{
      margin-left: 4px!important;
    }
    
    .el-menu--horizontal .el-menu .el-menu-item{
      padding: 0 10px !important;
    }
  }
</style>